<template>
  <div class="custom-page">
    <h1>Veranstaltungen</h1>
    <br>
    <div class="custom-page__content">
      <div class="forum__content" >
        <div id="forum__content">
          <div class="content__calendar">
            <FullCalendar :options="calendarOptions" ref="fc">
              <template v-slot:eventContent='arg'>
                <template v-if="arg.event.extendedProps && arg.event.extendedProps.isMultiDay">
                  <b class="event-title--indent">{{ arg.event.title }}</b>
                </template>
                <template v-else>
                  <b class="event-title--indent">{{ arg.event.title }}</b>
                </template>
              </template>
            </FullCalendar>
          </div>
          <Feed
            v-if="dayPostcards.length"
            ref="feedDay"
            class="content__feed"
            :postcards="dayPostcards"
          />
          <Feed
            v-if="selectedPostcardId"
            ref="feed"
            class="content__feed"
            :postcards="visiblePostcard"
          />
        </div>
      </div>
    </div>
    <Button
      icon="writePostcard"
      label_text="Veranstaltung hinzufügen"
      :is-icon="true"
      class="writePostcard"
      @click.native="
        $router.push({ name: 'createPostcard', params: { id: topic.topic_id } }), sendMatomoEvent()
      "
      @click="updateNav()"
    />
  </div>
</template>

<script>
import Feed from "@/components/Feed";
import Button from "@/components/Button";
import API from "@/services/api";
//import { getLoggedInUser } from "@/services/loggedIn";
import { toBoolean } from "../../../client-hubbel/src/services/utils";
//import { isMobile } from "@/services/utils";
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import deLocale from '@fullcalendar/core/locales/de';

export default {
  name: "Veranstaltungen",
  components: {
    Button,
    Feed,
    FullCalendar,
  },
  data() {
    return{
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: 'dayGridMonth',
        dateClick: this.onCalendarDateClick,
        eventClick: this.onCalendarEventClick,
        timeZone: 'Europe/Berlin',
        eventTimeFormat: { hour: '2-digit', minute: '2-digit' },
        displayEventEnd: true,
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'today next',
        },
        locale: deLocale,
        editable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        fixedWeekCount: false,
        eventsSet: () => {
          //this.handleEvents(events);
          // nach Render neu markieren (falls FC selbst Events sortiert/merged)
          this.$nextTick(() => this.markAllHasEvents());
        },

        // Beim View-Wechsel alle Markierungen löschen:
        datesSet: (arg) => {
          const root = arg?.view?.el;
          if (!root) return;
          root.querySelectorAll('.fc-daygrid-day.has-events')
              .forEach(el => el.classList.remove('has-events'));
          // neu berechnen
          this.$nextTick(() => this.markAllHasEvents());
        },

        // pro Event die Tage markieren (leicht angepasst, gleiche Logik)
        eventDidMount: (info) => {
          const root = info?.el?.closest?.('.fc');
          if (!root || !info?.event?.start) return;

          const isAllDay = info.event.allDay === true;

          // lokale Date-Objekte
          const s = new Date(info.event.start);
          const eRaw = info.event.end
            ? new Date(info.event.end)
            : new Date(s.getTime() + (isAllDay ? 86400000 : 60000));

          const eInclusive = isAllDay ? new Date(eRaw.getTime() - 1) : eRaw;

          const startDay = new Date(s.getFullYear(), s.getMonth(), s.getDate());
          const endDay   = new Date(eInclusive.getFullYear(), eInclusive.getMonth(), eInclusive.getDate());

          const pad = n => String(n).padStart(2, '0');
          const fmtLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;

          for (let cur = new Date(startDay); cur <= endDay; cur.setDate(cur.getDate() + 1)) {
            const ymd = fmtLocal(cur);
            const cell = root.querySelector(`.fc-daygrid-day[data-date="${ymd}"]`);
            if (cell) cell.classList.add('has-events');
          }
        },
      },
      category: "Event",
      postcards: [],
      selectedDateStr: null,
      selectedPostcardId: null,
      /*forum__head_isCollapsed: false,
      feed__info_isCollapsed: false,
      feed__info_isEditable: false,*/
      isEndReached: true,
      // NEU: einfache Sperre gegen doppelte Loads
      isLoadingMore: false,
      topic: {
        name: "Veranstaltungen",
        topic_id: -1,
        information:
          '<div><div>Hier findest Du anstehende Veranstaltungen und Events am Hubland. Dir fehlt ein Event? Dann lass es den hubbel wissen und schreibe es auf eine Postkarte!<br><br>Künftig ist hier auch ein “echter” Kalender geplant, um die Veranstaltungen übersichtlicher darzustellen.<br><br>Zuletzt bearbeitet: 28.07.2022<br>Themenpat*in: <router-link to="/about">hubbel Redaktion</router-link><br><br><br><br><br><br></div></div>',
      },
    }
  },

  watch: {
    postcards: {
      handler() {
        const api = this.$refs.fc && this.$refs.fc.getApi && this.$refs.fc.getApi();
        if (!api) return;
        this.syncCalendarFromPostcards();
      },
      deep: true,
    },
  },

  computed: {
    /**topicInformationTransformed() {
      return {
        template: this.topic.information,
        props: this.$options.props,
      };
    },
    loggedInUser() {
      try {
        return JSON.parse(getLoggedInUser());
      } catch (e) {
        return null;
      }
    },
    isMobile() {
      return isMobile();
    },**/
    visiblePostcard() {
      if (!this.selectedPostcardId) return [];
      return this.postcards.filter(pc => pc.id === this.selectedPostcardId);
    },
    dayPostcards() {
      if (!this.selectedDateStr) return [];
      return this.postcards.filter(pc =>
        this.isApproved(pc) &&
        pc.category === 'Event' &&
        this.postcardOccursOnDay(pc, this.selectedDateStr)
      );
    },
  },

  beforeMount() {
    (async () => {
      document.title = this.topic.name;
      await this.getInitialPosts();
      this.$nextTick(() => {
        this.syncCalendarFromPostcards();
      });
    })();
  },
  mounted() {
    const scroller = document.getElementById("forum__content");
    scroller && scroller.addEventListener("scroll", this.handleScroll, { passive: true });
    //this.feed__info_isCollapsed = window.innerWidth <= 960; // collapse on mobile
  },

  beforeDestroy() {
    const scroller = document.getElementById("forum__content");
    scroller && scroller.removeEventListener("scroll", this.handleScroll);
  },
  methods: {

    // Prüft Overlap eines Events mit einem Kalendertag
    overlapsDay(ev, dayDate) {
      const dayStart = new Date(dayDate);
      const dayEnd   = new Date(dayDate); dayEnd.setHours(23,59,59,999);

      const isAllDay = ev.allDay === true;

      const s = ev.start;
      let e = ev.end || new Date(s.getTime() + (isAllDay ? 86400000 : 60000));

      if (isAllDay) e = new Date(e.getTime() - 1);

      return (s <= dayEnd) && (e >= dayStart);
    },

    markCellHasEvents(cellEl, dateObj) {
      const api = this.$refs.fc?.getApi?.();
      if (!api || !cellEl || !dateObj) return;
      const hasAny = api.getEvents().some(ev => this.overlapsDay(ev, dateObj));
      cellEl.classList.toggle('has-events', hasAny);
    },

    markAllHasEvents() {
      const api = this.$refs.fc?.getApi?.();
      const root = api?.view?.el;
      if (!api || !root) return;

      root.querySelectorAll('.fc-daygrid-day').forEach(cell => {
        cell.classList.remove('has-events');
        const dateStr = cell.getAttribute('data-date');
        if (!dateStr) return;
        this.markCellHasEvents(cell, new Date(`${dateStr}T00:00:00`));
      });
    },

    onCalendarEventClick(info) {
      if (window.innerWidth < 960){
        return;
      }
      const fullId = info && info.event && info.event.id;
      if (!fullId) return;
      const rawId = String(fullId).startsWith('pc-') ? fullId.slice(3) : fullId;
      const asNumber = Number(rawId);
      this.selectedDateStr = null;
      this.selectedPostcardId = isNaN(asNumber) ? rawId : asNumber;

      this.$nextTick(() => {
        const feedEl = this.$refs.feed && (this.$refs.feed.$el || this.$refs.feed);
        if (feedEl && feedEl.scrollIntoView) feedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    },

    onCalendarDateClick(arg) {
      this.selectedDateStr = arg?.dateStr || null; // "YYYY-MM-DD"
      this.selectedPostcardId = null;

      this.$nextTick(() => {
        if (!this.dayPostcards.length) {
          this.selectedDateStr = null; // nichts an diesem Tag
          return;
        }
        const el = this.$refs.feedDay && (this.$refs.feedDay.$el || this.$refs.feedDay);
        el?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
      });
    },

    /**
    toggleBgInfo() {
      this.feed__info_isCollapsed = !this.feed__info_isCollapsed
      setTimeout(this.resizeCalendar, 50)
    },**/

    toLocalIsoNoTZ(value) {
      if (!value) return null;
      // Akzeptiere "YYYY-MM-DDTHH:mm" direkt
      var re = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
      if (typeof value === 'string' && re.test(value)) return value;

      // Schneide Sekunden optional weg
      var reSec = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
      if (typeof value === 'string' && reSec.test(value)) return value.slice(0, 16);

      try {
        var d = new Date(value);
        if (!isNaN(d.getTime())) {
          var pad = function(n){ return String(n).padStart(2, '0'); };
          return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) +
                'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
        }
      } catch (e) {
        return null;
      }

      return null;
    },

    isApproved(pc) {
      if (!pc) return false;
      var v = pc.approved;
      return v === true || v === 1 || v === "1" || v === "true";
    },

    postcardToCalendarEvent(pc) {
      if (!pc || !pc.eventTitle || !pc.eventStartDateTime) return null;

      var startIso = this.toLocalIsoNoTZ(pc.eventStartDateTime);
      var endIso   = this.toLocalIsoNoTZ(pc.eventEndDateTime);
      if (!startIso) return null;

      return {
        id: 'pc-' + pc.id,
        title: pc.eventTitle,
        location: pc.eventLocation,
        start: startIso,
        end: endIso || null,
        allDay: false,
      };
    },

    addCalendarEventFromPost(pc) {
      var api = this.$refs.fc && this.$refs.fc.getApi && this.$refs.fc.getApi();
      if (!api) return;

      if (!this.isApproved(pc)) {
        var existingNot = api.getEventById('pc-' + pc.id);
        if (existingNot) existingNot.remove();
        return;
      }

      var evt = this.postcardToCalendarEvent(pc);
      if (!evt) return;

      var existing = api.getEventById(evt.id);
      if (existing) existing.remove();
      api.addEvent(evt);
    },

    syncCalendarFromPostcards() {
      var api = this.$refs.fc && this.$refs.fc.getApi && this.$refs.fc.getApi();
      if (!api) return;
      api.removeAllEvents();
      for (var i = 0; i < this.postcards.length; i++) {
        var pc = this.postcards[i];
        if (this.isApproved(pc)) {
          this.addCalendarEventFromPost(pc);
        }
      }
      this.$nextTick(() => this.markAllHasEvents());
    },

    safeToDate(v) {
      if (!v) return new Date('invalid');
      const str = typeof v === 'string' ? v.replace(' ', 'T') : v;
      return new Date(str);
    },

    postcardOccursOnDay(pc, ymd /* "YYYY-MM-DD" */) {
      if (!pc || !pc.eventStartDateTime) return false;
      const dayStart = new Date(`${ymd}T00:00:00`);
      const dayEnd   = new Date(`${ymd}T23:59:59.999`);
      const start = this.safeToDate(pc.eventStartDateTime);
      const end   = this.safeToDate(pc.eventEndDateTime) || new Date(start.getTime() + 60 * 1000);
      if (isNaN(start) || isNaN(end)) return false;
      return (start < dayEnd) && (end > dayStart); // Overlap
    },

    sendMatomoEvent() {
      if (!toBoolean(process.env.VUE_APP_USE_MATOMO)) return;
      window._paq && window._paq.push && window._paq.push([
        "trackEvent",
        "CreatePostcard on hubbel",
        "Click 'Write Postcard' Button",
        "'Write Postcard' clicked.",
      ]);
    },
    /**loggedIn() {
      try {
        return getLoggedInUser() !== null;
      } catch (e) {
        return false;
      }
    },**/
    updateNav() {
      this.$emit("update_Nav");
    },
    handleScroll() {
      //handle topbar collapse
      //const forum__head = document.getElementById("forum__head");
      const forum__content = document.getElementById("forum__content");
      if (!forum__content) return;

      /**if (this.postcards.length > 1) {
        if (forum__content.scrollTop > 100) this.forum__head_isCollapsed = true;
        else if (!forum__head || forum__head.style.height !== "200px") this.forum__head_isCollapsed = false;
      }**/

      //load more posts (Sperre gegen Doppelaufrufe)
      if (!this.$route.params.post_id && !this.isEndReached && !this.isLoadingMore) {
        if (
          forum__content.scrollTop + forum__content.clientHeight >=
          forum__content.scrollHeight * 0.75
        ) {
          this.isLoadingMore = true;
          API.getNextPostsforCategory(
            this.category,
            3,
            this.postcards.length,
            this.postcards[0]?.id
          ).then((res) => {
            res.data.forEach((postObj) => this.postcards.push(this.renderPost(postObj)));
            this.isEndReached = res.data.length <= 0;
          }).finally(() => {
            this.isLoadingMore = false;
          });
        }
      }
    },

    /**toggleEditTopicText() {
     this.feed__info_isEditable = !this.feed__info_isEditable;
     if (!this.feed__info_isEditable) {
     this.topic.information = this.topicInformationText;
     }
     },**/
    renderPost(postObj) {
      if (!postObj || this.postcards.some((e) => e.id === postObj.post_id)) {
        return;
      }

      function getSender() {
        if (postObj.sender_name) {
          return postObj.sender_name;
        } else if (postObj.user?.team && postObj.user.team.length > 0) {
          return postObj.user.team;
        } else if (!postObj.user?.last_name || postObj.user.last_name.length <= 0) {
          return postObj.user?.first_name || "";
        } else {
          return postObj.user.first_name + " " + Array.from(postObj.user.last_name)[0] + ".";
        }
      }
      const createdAtParts = (postObj.createdAt || '').split(/[T.]/);
      const createdDate = createdAtParts.length >= 2 ? (createdAtParts[0] + " " + createdAtParts[1]) : "";

      this.postcards.push({
        id: postObj.post_id,
        readOnly: true,
        approved: postObj.approved,
        category: postObj.category,
        sender_verified: postObj.user?.verified,
        sender_team: postObj.user?.team,
        sender: getSender(),
        sender_name_mailbox: postObj.sender_name,
        subject: postObj.topic?.name,
        allTopicNames: postObj.allTopicNames,
        text: postObj.text,
        eventTitle: postObj.eventTitle,
        eventLocation: postObj.eventLocation,
        eventStartDateTime: postObj.eventStartDateTime,
        eventEndDateTime: postObj.eventEndDateTime,
        date: createdDate,
        attachments: postObj.Attachments,
        isSaved: postObj.isSaved,
        sentFrom: postObj.sentFrom,
        show: false,
      })
      this.$nextTick(() => {
        const last = this.postcards[this.postcards.length - 1]
        this.addCalendarEventFromPost(last)
      });
    },

    getInitialPosts() {
      // initialer Load setzt isEndReached auf false, damit Scroll-Loading aktiv wird
      this.isEndReached = false;

      //Hinweis: Limit zum Laden nächster Posts muss hoch genug sein, dass alle Veranstaltungen geladen werden
      return API.getNextPostsforCategory(this.category, 100, 0, -1).then((res) => {
        res.data.forEach((postObj) => this.renderPost(postObj));
        if (!res.data?.length) this.isEndReached = true;
      });
    },
    /**sendUpdatedTopicInformation() {
     API.updateTopicInformation(this.topic.topic_id, this.topicInformationText).then(() => {
     this.toggleEditTopicText();
     });
     },**/
  },
};
</script>

<style>
  .v-application a {
    color: rgba(0, 0, 0, 0.87) !important;
  }

  .event-title--indent {
    margin-left: 10px;
  }

  @media (max-width: 500px) {
    .fc .fc-toolbar-title {
        font-size: larger;
    }
  }

  @media (max-width: 960px) {
    .fc .fc-daygrid-day .fc-daygrid-event,
    .fc .fc-daygrid-day .fc-daygrid-more-link {
      display: none !important;
    }

    .fc .fc-daygrid-day.has-events .fc-daygrid-day-frame {
      background-color: #f7b32b !important;
      border-radius: 6px;
      padding: 2px;
    }
  }

  .fc .fc-button .fc-icon {
    vertical-align: bottom;
  }

  .fc-h-event .fc-event-main {
    color: #000 !important;
  }

  .fc .fc-button-primary {
    background-color: rgba(0, 0, 0, 0.87);
  }

  .fc .fc-button:disabled {
    opacity: 1 !important;
  }

  .fc .fc-button-primary:disabled {
    background-color: rgba(0, 0, 0, 0.87);
  }

  .fc .fc-highlight {
    background: #EEEEEE !important;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background-color: transparent;
    border-top: 4px solid;
  }

  .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top a {
    -webkit-text-stroke: medium;
  }

  .fc .fc-daygrid-event.fc-event.multi-day-event {
    background-color: #f7b32b !important;
    color: #000 !important;
    border: none !important;
  }

  .fc .fc-daygrid-event.fc-event.multi-day-event .fc-event-time {
    display: inline !important;
  }

  .fc .fc-daygrid-event.fc-event:not(.multi-day-event) {
    background-color: #f7b32b;
    color: #000 !important;
    border: none !important;
  }

  .fc-daygrid-day.is-selected-day {
    background-color: #000 !important;
  }

  .fc .fc-daygrid-event.fc-event:not(.multi-day-event) .fc-event-time {
    display: none !important;
  }

  .fc .fc-daygrid-event {
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    display: block !important;
    max-width: 100% !important;
    padding: 2px 0px;
  }

  .fc .fc-daygrid-event .fc-event-title {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    display: inline-block !important;
    max-width: 100% !important;
  }

  .fc .fc-daygrid-event .fc-event-time {
    flex-shrink: 0;
  }

  .feed__end {
    display: none;
  }
</style>
